type ClassValue = string | number | boolean | undefined | null | Record<string, boolean>;

export function cn(...classes: ClassValue[]): string {
  return classes
    .reduce<string[]>((acc, item) => {
      if (!item) return acc;
      if (typeof item === 'string' || typeof item === 'number') {
        acc.push(String(item));
      } else if (typeof item === 'object') {
        Object.entries(item).forEach(([key, value]) => {
          if (value) acc.push(key);
        });
      }
      return acc;
    }, [])
    .join(' ');
}
